import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    // mode: 'history',
    routes: [{
            path: '/pages/shop/index',
            name: 'index',
            component: () =>
                import ('../pages/index.vue'),
            meta: {
                title: "东莞东城国际酒店"
            }
        },
        {
            path: '/',
            // path: '/pages/shop/index',
            name: 'shopIndex',
            component: () =>
                import ('../pages/shop/index.vue'),
            meta: {
                title: "东莞东城国际酒店微商城"
            }
        },
        {
            path: '/UEditor',
            name: 'UEditor',
            component: () =>
                import ('../components/UEditor'),
            meta: {
                title: "编辑器"
            }
        },
        {
            path: '/pages/shop/shopIndex',
            name: 'shopIndexs',
            component: () =>
                import ('../pages/shop/shopIndex.vue'),
            meta: {
                title: "商品推广"
            }
        },
        {
            path: '/pages/shop/hotActive',
            name: 'hotActives',
            component: () =>
                import ('../pages/shop/hotActive.vue'),
            meta: {
                title: "热门活动"
            }
        },
        {
            path: '/pages/order/index',
            name: 'orderIndex',
            component: () =>
                import ('../pages/order/index.vue'),
            meta: {
                title: "订单"
            }
        }, {
            path: '/pages/mine/index',
            name: 'mineIndex',
            component: () =>
                import ('../pages/mine/index.vue'),
            meta: {
                title: "个人中心"
            }
        }, {
            path: '/pages/reserve/checkConditions',
            name: 'checkConditions',
            component: () =>
                import ('../pages/reserve/checkConditions.vue'),
            meta: {
                title: "入驻条件"
            }
        },
        {
            path: '/pages/reserve/checkDate',
            name: 'checkDate',
            component: () =>
                import ('../pages/reserve/checkDate.vue'),
            meta: {
                title: "选择日期"
            }
        },
        {
            path: '/pages/reserve/hotelDetail',
            name: 'hotelDetail',
            component: () =>
                import ('../pages/reserve/hotelDetail.vue'),
            meta: {
                title: "酒店详情"
            }
        },
        {
            path: '/pages/reserve/hotelDesc',
            name: 'hotelDesc',
            component: () =>
                import ('../pages/reserve/hotelDesc.vue'),
            meta: {
                title: "酒店详情"
            }
        },
        {
            path: '/pages/reserve/catering',
            name: 'catering',
            component: () =>
                import ('../pages/reserve/catering.vue'),
            meta: {
                title: "餐饮"
            }
        },
        {
            path: '/pages/reserve/hotelPhoto',
            name: 'hotelPhoto',
            component: () =>
                import ('../pages/reserve/hotelPhoto.vue'),
            meta: {
                title: "酒店相册"
            }
        },
        {
            path: '/pages/reserve/order/orderFill',
            name: 'orderFill',
            component: () =>
                import ('../pages/reserve/order/orderFill.vue'),
            meta: {
                title: "订单填写"
            }
        },
        {
            path: '/pages/reserve/order/personList',
            name: 'personList',
            component: () =>
                import ('../pages/reserve/order/personList.vue'),
            meta: {
                title: "选择入住人"
            }
        },
        {
            path: '/pages/reserve/order/storeTime',
            name: 'storeTime',
            component: () =>
                import ('../pages/reserve/order/storeTime.vue'),
            meta: {
                title: "到店时间"
            }
        },
        {
            path: '/pages/reserve/order/otherNeed',
            name: 'otherNeed',
            component: () =>
                import ('../pages/reserve/order/otherNeed.vue'),
            meta: {
                title: "其他需求"
            }
        },
        {
            path: '/pages/reserve/order/invoiceTitle',
            name: 'invoiceTitle',
            component: () =>
                import ('../pages/reserve/order/invoiceTitle.vue'),
            meta: {
                title: "发票"
            }
        }, {
            path: '/pages/reserve/order/coupon',
            name: 'coupon',
            component: () =>
                import ('../pages/reserve/order/coupon.vue'),
            meta: {
                title: "优惠券"
            }
        }, {
            path: '/orderPay',
            name: 'orderPay',
            component: () =>
                import ('../components/orderPay.vue'),
            meta: {
                title: "订单支付"
            }
        },
        {
            path: '/orderPayV',
            name: 'orderPay',
            component: () =>
                import ('../components/orderPayV.vue'),
            meta: {
                title: "订单支付"
            }
        }, {
            path: '/paySuccess',
            name: 'paySuccess',
            component: () =>
                import ('../components/paySuccess.vue'),
            meta: {
                title: "支付成功"
            }
        },
        {
            path: '/pages/reserve/order/evaluate',
            name: 'evaluate',
            component: () =>
                import ('../pages/reserve/order/evaluate.vue'),
            meta: {
                title: "评价"
            }
        },
        // 商城
        {
            path: '/pages/shop/classifyList',
            name: 'classifyList',
            component: () =>
                import ('../pages/shop/classifyList.vue'),
            meta: {
                title: "商城列表"
            }
        },
        {
            path: '/pages/shop/shopClassify',
            name: 'shopClassify',
            component: () =>
                import ('../pages/shop/shopClassify.vue'),
            meta: {
                title: "商品分类"
            }
        },
        {
            path: '/pages/shop/shopSearch',
            name: 'shopSearch',
            component: () =>
                import ('../pages/shop/shopSearch.vue'),
            meta: {
                title: "商品搜索"
            }
        }, {
            path: '/pages/shop/shopDetail',
            name: 'shopDetail',
            component: () =>
                import ('../pages/shop/shopDetail.vue'),
            meta: {
                title: "东莞东城国际酒店"
            }
        }, {
            path: '/pages/shop/questions',
            name: 'questions',
            component: () =>
                import ('../pages/shop/questions.vue'),
            meta: {
                title: "商品问答"
            }
        }, {
            path: '/pages/shop/shopCart',
            name: 'shopCart',
            component: () =>
                import ('../pages/shop/shopCart.vue'),
            meta: {
                title: "购物车"
            }
        }, {
            path: '/pages/shop/orderFillV',
            name: 'orderFill',
            component: () =>
                import ('../pages/shop/orderFillV.vue'),
            meta: {
                title: "商品订单"
            }
        },
        // {
        //     path: '/pages/shop/orderFillVCS',
        //     name: 'orderFillCS',
        //     component: () =>
        //         import ('../pages/shop/orderFillVCS.vue'),
        //     meta: {
        //         title: "商品订单"
        //     }
        // },
        // {
        //     path: '/pages/shop/invoiceList',
        //     name: 'invoiceList',
        //     component: () =>
        //         import ('../pages/shop/invoiceList.vue'),
        //     meta: {
        //         title: "发票"
        //     }
        // },
        {
            path: '/pages/shop/addressList',
            name: 'addressList',
            component: () =>
                import ('../pages/shop/addressList.vue'),
            meta: {
                title: "地址"
            }
        },
        {
            path: '/pages/shop/couponList',
            name: 'couponList',
            component: () =>
                import ('../pages/shop/couponList.vue'),
            meta: {
                title: "优惠券"
            }
        }, {
            path: '/addPerson',
            name: 'addPerson',
            component: () =>
                import ('../components/addPerson.vue'),
            meta: {
                title: "添加入住人"
            }
        }, {
            path: '/addInvoice',
            name: 'addInvoice',
            component: () =>
                import ('../components/addInvoice.vue'),
            meta: {
                title: "添加发票"
            }
        }, {
            path: '/addAddress',
            name: 'addAddress',
            component: () =>
                import ('../components/addAddress.vue'),
            meta: {
                title: "添加地址"
            }
        },
        {
            path: '/invoiceList',
            name: 'invoiceList',
            component: () =>
                import ('../components/invoiceList.vue'),
            meta: {
                title: "发票"
            }
        },
        // 个人中心
        {
            path: '/pages/mine/register',
            name: 'register',
            component: () =>
                import ('../pages/mine/register.vue'),
            meta: {
                title: "东城国际酒店会员注册"
            }
        },
        {
            path: '/pages/mine/registerSuccess',
            name: 'registerSuccess',
            component: () =>
                import ('../pages/mine/registerSuccess.vue'),
            meta: {
                title: "注册成功"
            }
        },
        {
            path: '/pages/mine/login',
            name: 'login',
            component: () =>
                import ('../pages/mine/login.vue'),
            meta: {
                title: "东城国际酒店会员登录"
            }
        },
        {
            path: '/pages/mine/commonInfo',
            name: 'commonInfo',
            component: () =>
                import ('../pages/mine/commonInfo.vue'),
            meta: {
                title: "常用消息"
            }
        },
        {
            path: '/pages/mine/holding/coupon',
            name: 'holding/coupon',
            component: () =>
                import ('../pages/mine/holding/coupon.vue'),
            meta: {
                title: "优惠券"
            }
        },
        {
            path: '/pages/mine/retrieve',
            name: 'retrieve',
            component: () =>
                import ('../pages/mine/retrieve.vue'),
            meta: {
                title: "找回密码"
            }
        },
        {
            path: '/pages/mine/retrieveSuccess',
            name: 'retrieveSuccess',
            component: () =>
                import ('../pages/mine/retrieveSuccess.vue'),
            meta: {
                title: "找回密码"
            }
        },
        {
            path: '/pages/mine/editName',
            name: 'editName',
            component: () =>
                import ('../pages/mine/editName.vue'),
            meta: {
                title: "修改称呼"
            }
        },
        {
            path: '/pages/mine/editPassword',
            name: 'editPassword',
            component: () =>
                import ('../pages/mine/editPassword.vue'),
            meta: {
                title: "修改密码"
            }
        },
        {
            path: '/pages/mine/myInfo',
            name: 'myInfo',
            component: () =>
                import ('../pages/mine/myInfo.vue'),
            meta: {
                title: "个人信息"
            }
        }, {
            path: '/pages/mine/makeGiven/myGiven',
            name: 'myGiven',
            component: () =>
                import ('../pages/mine/makeGiven/myGiven.vue'),
            meta: {
                title: "我的转赠"
            }
        }, {
            path: '/pages/mine/makeGiven/toGiven',
            name: 'toGiven',
            component: () =>
                import ('../pages/mine/makeGiven/toGiven.vue'),
            meta: {
                title: "我的转赠"
            }
        }, {
            path: '/pages/mine/makeGiven/givenSuccess',
            name: 'givenSuccess',
            component: () =>
                import ('../pages/mine/makeGiven/givenSuccess.vue'),
            meta: {
                title: "转赠成功"
            }
        }, {
            path: '/pages/mine/order/shopOrder',
            name: 'shopOrder',
            component: () =>
                import ('../pages/mine/order/shopOrder.vue'),
            meta: {
                title: "商品订单"
            }
        }, {
            path: '/pages/mine/order/shopOrderDetail',
            name: 'shopOrderDetail',
            component: () =>
                import ('../pages/mine/order/shopOrderDetail.vue'),
            meta: {
                title: "商品订单详情"
            }
        }, {
            path: '/pages/shopCharge',
            name: 'shopCharge',
            component: () =>
                import ('../pages/mine/order/shopCharge.vue'),
            meta: {
                title: "商品核销"
            }
        }, {
            path: '/pages/mine/order/shopOrderLogistics',
            name: 'shopOrderLogistics',
            component: () =>
                import ('../pages/mine/order/shopOrderLogistics.vue'),
            meta: {
                title: "物流信息"
            }
        }, {
            path: '/pages/mine/order/hotelOrder',
            name: 'hotelOrder',
            component: () =>
                import ('../pages/mine/order/hotelOrder.vue'),
            meta: {
                title: "酒店订单"
            }
        }, {
            path: '/pages/mine/order/hotelOrderDetail',
            name: 'hotelOrderDetail',
            component: () =>
                import ('../pages/mine/order/hotelOrderDetail.vue'),
            meta: {
                title: "酒店订单详情"
            }
        }, {
            path: '/pages/mine/afterSale/myAfterSale',
            name: 'myAfterSale',
            component: () =>
                import ('../pages/mine/afterSale/myAfterSale.vue'),
            meta: {
                title: "我的售后"
            }
        }, {
            path: '/pages/mine/afterSale/afterSaleDetail',
            name: 'afterSaleDetail',
            component: () =>
                import ('../pages/mine/afterSale/afterSaleDetail.vue'),
            meta: {
                title: "我的售后"
            }
        }, {
            path: '/pages/mine/question/myQuest',
            name: 'myQuest',
            component: () =>
                import ('../pages/mine/question/myQuest.vue'),
            meta: {
                title: "商品问答"
            }
        }, {
            path: '/pages/mine/question/questDetail',
            name: 'questDetail',
            component: () =>
                import ('../pages/mine/question/questDetail.vue'),
            meta: {
                title: "商品问答详情"
            }
        }, {
            path: '/pages/mine/hotelOrderComment',
            name: 'hotelOrderComment',
            component: () =>
                import ('../pages/mine/hotelOrderComment.vue'),
            meta: {
                title: "点评"
            }
        }, {
            path: '/pages/mine/myComment',
            name: 'myComment',
            component: () =>
                import ('../pages/mine/myComment.vue'),
            meta: {
                title: "我的点评"
            }
        }, {
            path: '/pages/mine/memberEquity',
            name: 'memberEquity',
            component: () =>
                import ('../pages/mine/memberEquity.vue'),
            meta: {
                title: "会员权益"
            }
        }, {
            path: '/pages/mine/holding/coupon',
            name: 'coupon',
            component: () =>
                import ('../pages/mine/holding/coupon.vue'),
            meta: {
                title: "我的优惠券"
            }
        }, {
            path: '/pages/mine/myPoint',
            name: 'myPoint',
            component: () =>
                import ('../pages/mine/myPoint.vue'),
            meta: {
                title: "我的积分"
            }
        },
        {
            path: '/pages/mine/signIn',
            name: 'signIn',
            component: () =>
                import ('../pages/mine/signIn.vue'),
            meta: {
                title: "签到"
            }
        }, {
            path: '/pages/mine/turntable',
            name: 'turntable',
            component: () =>
                import ('../pages/mine/turntable.vue'),
            meta: {
                title: "大转盘"
            }
        }, {
            path: '/pages/mine/distCenter/index',
            name: 'distCenter/index',
            component: () =>
                import ('../pages/mine/distCenter/index.vue'),
            meta: {
                title: "分销中心"
            }
        }, {
            path: '/pages/mine/distCenter/settle',
            name: 'distCenter/settle',
            component: () =>
                import ('../pages/mine/distCenter/settle.vue'),
            meta: {
                title: "结算中心"
            }
        }, {
            path: '/pages/mine/distCenter/deposit',
            name: 'distCenter/deposit',
            component: () =>
                import ('../pages/mine/distCenter/deposit.vue'),
            meta: {
                title: "提现"
            }
        }, {
            path: '/pages/mine/distCenter/record',
            name: 'distCenter/record',
            component: () =>
                import ('../pages/mine/distCenter/record.vue'),
            meta: {
                title: "收支明细"
            }
        }, {
            path: '/pages/mine/holding/getCoupon',
            name: 'getCoupon',
            component: () =>
                import ('../pages/mine/holding/getCoupon.vue'),
            meta: {
                title: "领劵啦"
            }
        },
        {
            path: '/wxFans',
            name: 'wxFans',
            component: () =>
                import ('../pages/shop/wxFans.vue'),
            meta: {
                title: "东城国际酒店微信粉丝群"
            }
        },
    ],
    //跳转回到最顶部
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    },
})


// WEBPACK FOOTER //
// ./src/router/index.js